import * as React from "react";
import {
  Menu,
  Button,
  Stack,
  Checkbox,
  FormLabel,
  FormGroup,
  FormControl,
  FormHelperText,
  FormControlLabel,
  IconButton,
} from "@mui/material";
import Export from "./Export";
import CloudDownloadRoundedIcon from "@mui/icons-material/CloudDownloadRounded";

const cols = {
  show_email: { label: "ایمیل", value: 1 },
  show_address: { label: "آدرس", value: 0 },
  show_type_id: { label: "نوع کاربر", value: 1 },
};

export default function Download({ url, filter }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [columns, setColumns] = React.useState(() =>
    Object.fromEntries(Object.entries(cols).map(([k, { value }]) => [k, value]))
  );

  const renderCheckboxes = () =>
    Object.entries(cols).map(([key, { label }]) => (
      <FormControlLabel
        key={key}
        label={label}
        control={
          <Checkbox
            size="small"
            color="success"
            name={key}
            checked={columns[key]}
            onChange={(e) =>
              setColumns((prev) => ({ ...prev, [key]: +e.target.checked }))
            }
          />
        }
      />
    ));

  return (
    <>
      <IconButton
        size="small"
        color="success"
        sx={{ bgcolor: "action.hover" }}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <CloudDownloadRoundedIcon />
      </IconButton>
      <Menu
        dir="rtl"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        slotProps={{ list: { sx: { p: 1 } } }}
      >
        <Stack p={1}>
          <FormControl size="small" component="fieldset">
            <FormLabel>نمایش ستون ها</FormLabel>
            <FormGroup>{renderCheckboxes()}</FormGroup>
            <FormHelperText>ستون های مورد نظر در اکسل</FormHelperText>
          </FormControl>
        </Stack>
        <Export
          url={url}
          filter={filter}
          columns={columns}
          onClose={() => setAnchorEl(null)}
        />
      </Menu>
    </>
  );
}
